import React from "react";
import EmailChangeVerification from "../components/Authentication/EmailChangeVerification";

const EmailChangeVerificationPage = () => {
  return <EmailChangeVerification />;
};

export default EmailChangeVerificationPage;